
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import SectionLink from './section-link'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "sectionlink"
    }}>{`SectionLink`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "section-link"
    }}>{`Section link`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For linking to editorial sections.`}</p>
    <Playground __position={1} __code={'<SectionLink title=\"Section link\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionLink
    }} mdxType="Playground">
  <SectionLink title='Section link' href='/' mdxType="SectionLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={SectionLink} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;